import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { Locale } from '@fastnorth/i18next';
import { Flex } from '@fastnorth/kraken/components/layout';
import { H2 } from '@fastnorth/kraken/components/typography';
import formatProgressTime from '../utils/formatProgressTime';
import { subEventProgressHeadingId } from '../utils/scrollToSubEventProgressSection';
import { raceSectionHeadingVariants, raceSectionMetaVariants } from './RaceSectionHeader.styles';

export type RaceSectionHeaderProps = {
  raceName: string;
  resultsLastModifiedAt: string;
  subEventId: string;
  timeZone: string;
};

const RaceSectionHeader = ({
  raceName,
  resultsLastModifiedAt,
  subEventId,
  timeZone,
}: RaceSectionHeaderProps): ReactElement => {
  const { i18n, t } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });
  const locale = i18n.language as Locale;
  const resultsAsOfTime =
    formatProgressTime(resultsLastModifiedAt, locale, timeZone) ?? resultsLastModifiedAt;

  return (
    <Flex className="mb-4 w-full min-w-0 items-center justify-between gap-4">
      <H2
        className={raceSectionHeadingVariants()}
        id={subEventProgressHeadingId(subEventId)}
        spacing="0">
        {raceName}
      </H2>
      <span className={raceSectionMetaVariants()}>
        {t('results_as_of', { time: resultsAsOfTime })}
      </span>
    </Flex>
  );
};

export default RaceSectionHeader;
